(function ($) {
    $(function () {
        var $relatedBooks = $('.js-post-related-books');
        if ($relatedBooks.length === 0) {
            return;
        }
 
        function relatedBooksCarousel() {
            $('.upt-posts-related-books__carousel').slick({
                dots: false,
                slide: 'div.upt-posts-related-books__carousel--book',
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });
        } 

        function ajaxRelatedBooks() { 
            var data = {
                action: 'upt_ajax_post_related_books',
                isbns: $relatedBooks.data('isbns')
            };
            $.ajax(universityPressThemeSettings.wordpressAjaxUrl, {
                dataType: 'html',
                method: 'GET',
                data: data,
                success: function (data) {
                    $relatedBooks.hide().html(data).fadeIn(500);
                    relatedBooksCarousel(); 
                },
                error: function (xhr, type, err) {
                    $relatedBooks.hide();
                }
            });
        }

        ajaxRelatedBooks();

    });
})(jQuery);